import { FaEdit } from "react-icons/fa";
import Tooltip from "../ToolTip";

const EditButton = ({ action, content }) => {
  return (
    <Tooltip content={content}>
      <button
        onClick={() => action ? action() : null}
        className="p-1.5 text-green-500 hover:bg-green-600 hover:bg-opacity-25 hover:cursor-pointer rounded-md bg-green-700 bg-opacity-10 flex transition-all duration-100 items-center"
      >
        <FaEdit className="text-[10px]"/>
      </button>
    </Tooltip>
  )
}

export default EditButton;
